export default __webpack_public_path__ + "static/media/xpensityV1-lg-3.2657ba68.webp";